export default "\r\n<img [src]=\"src\" class=\"picture-box\" [style]=\"style\" />"